<template>
  <div class="c-table" ref="recordCptable">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'reportMonth'">{{ scope.row[col.key] }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该游戏分成吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small" class="c-control-margin">&ensp;删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'cpRate'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'recordCptable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  }
}
</script>
